export function addGoogleAnalyticsScripts(gtag){
  let script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtag}`;
  script.async = true;
  document.head.appendChild(script);

  script = document.createElement("script");
  script.type = "text/javascript";
  script.innerText=
    `window.dataLayer = window.dataLayer || [];
       function gtag(){dataLayer.push(arguments);}
       gtag('js', new Date());
       gtag('config', '${gtag}');`;
  document.head.appendChild(script);
}

export function createCookieScript(cookieScriptUrl) {
  const script = document.createElement("script");
  script.id = "AVConsent";
  script.type = "text/javascript";
  script.src = cookieScriptUrl;
  script.lang = "ro";
  document.head.appendChild(script);
};